import React from 'react';
export const HeroSection = () => {
  return <div className="w-full bg-black text-white py-12 px-4 md:px-8" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-center" data-id="element-76">
          Welcome to FRZN: Jewelry That Reminds You Who You Are
        </h1>
        <div className="flex justify-center mb-8" data-id="element-77">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tsQTh3Pn1fCgMi7hfFrpa2/20250705_2100_Jewelry_Display_Focus_remix_01jzektbv8emcb6g8084q9f9c7.png" alt="FRZN Jewelry collection display" className="w-full max-w-2xl rounded-md shadow-lg" data-id="element-78" />
        </div>
        <div className="inline-block bg-white text-black font-medium px-4 py-2 rounded-full text-sm mb-8" data-id="element-79">
          🔥 20,000+ customers trust our quality
        </div>
        <p className="text-lg md:text-xl leading-relaxed mb-6" data-id="element-80">
          Hey — I'm Tim Moore, the guy behind FRZN Jewelry. If you're anything
          like I was back in 2019, you want to look like the man… even if your
          bank account's saying otherwise.
        </p>
      </div>
    </div>;
};